/**
 * AuthPage
 *
 */

import queryString from 'querystring';
import styled from 'styled-components';
import { connect } from 'react-redux';
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Auth, Hub } from 'aws-amplify';
import Authpage from '@ts/pages/AuthPage';
import { PushPrefetchedLocation } from '@ts/components/PrefetchRoute';

export const Error = styled.h3`
    padding: 18px;
    margin: 0;
`;

/* eslint-disable react/prefer-stateless-function */
function AuthPage({ dispatch }) {
    // const [user, setUserData] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');

    const redirectLink = useMemo(() => {
        const authRedirect =
            typeof sessionStorage !== 'undefined'
                ? JSON.parse(sessionStorage.getItem('authRedirect'))
                : null;
        if (authRedirect) {
            return authRedirect.link + authRedirect.params;
        }
        return '/';
    }, []);

    const getUser = useCallback(
        async (redirectLink) => {
            await Auth.currentAuthenticatedUser()
                .then(() => {
                    // setUserData(user);
                    // setAuthLoading(false);
                    PushPrefetchedLocation(redirectLink, dispatch);
                })
                .catch((err) => {
                    console.error('getUser', err.message);
                    setErrorMessage(err.message);
                });
        },
        [dispatch]
    );

    useEffect(() => {
        Hub.listen('auth', ({ payload: { event } }) => {
            switch (event) {
                case 'signIn':
                    getUser(redirectLink);
                    break;
            }
        });

        if (window.location.href.search('error_description') !== -1) {
            const error = queryString.parse(window.location.search.slice(1));
            const errorMessage =
                error && error.error ? `Error: ${error.error} - ${error.error_description}` : '';
            setErrorMessage(errorMessage);
        }
    }, [setErrorMessage, getUser, redirectLink]);

    if (errorMessage) {
        return <Error>{errorMessage}</Error>;
    }

    return <Authpage />;
}

const mapDispatchToProps = (dispatch) => ({ dispatch: (action) => dispatch(action) });

export default connect(null, mapDispatchToProps)(AuthPage);
